angular
  .module('countriesApp')
  .constant('API_PATHS', {
    'COUNTRIES': '/api/countries'
  })
  .constant('HEADERS_AWS_PATH', 'https://devex-web.s3.amazonaws.com/images/countries/headers/')
  .constant('RELATIVE_PATHS', {
    'AGGREGATED_SECTORS': 'funding/sectors',
    'AGGREGATED_FUNDERS': 'funding/funders',
    'FUNDING_INFOS': 'funding/funding_infos',
    'CONTRACTS': 'funding/contracts',
    'PIPELINES': 'funding/pipelines'
  })
  .constant('VISUALIZATION_ITEMS', 10)
  .constant('SDG', {
    1: {
      name: 'No poverty',
      description: 'End poverty in all its forms everywhere'
    },
    2: {
      name: 'Zero hunger',
      description: 'End hunger, achieve food security and improved nutrition and promote ' +
      'sustainable agriculture'
    },
    3: {
      name: 'Good health and well-being',
      description: 'Ensure healthy lives and promote well-being for all at all ages'
    },
    4: {
      name: 'Quality education',
      description: 'Ensure inclusive and equitable quality education and promote lifelong ' +
      'learning opportunities for all'
    },
    5: {
      name: 'Gender equality',
      description: 'Achieve gender equality and empower all women and girls'
    },
    6: {
      name: 'Clean water and sanitation',
      description: 'Ensure availability and sustainable management of water and sanitation for all'
    },
    7: {
      name: 'Affordable and clean energy',
      description: 'Ensure access to affordable, reliable, sustainable and modern energy for all'
    },
    8: {
      name: 'Decent work and economic growth',
      description: 'Promote sustained, inclusive and sustainable economic growth, full and ' +
      'productive employment and decent work for all'
    },
    9: {
      name: 'Industry, innovation and infrastructure',
      description: 'Build resilient infrastructure, promote inclusive and sustainable ' +
      'industrialization and foster innovation'
    },
    10: {
      name: 'Reduced inequalities',
      description: 'Reduce inequality within and among countries'
    },
    11: {
      name: 'Sustainable cities and communities',
      description: 'Make cities and human settlements inclusive, safe, resilient and sustainable'
    },
    12: {
      name: 'Responsible consumption and production',
      description: 'Ensure sustainable consumption and production patterns'
    },
    13: {
      name: 'Climate action',
      description: 'Take urgent action to combat climate change and its impacts*'
    },
    14: {
      name: 'Life below water',
      description: 'Conserve and sustainably use the oceans, seas and marine resources for ' +
      'sustainable development'
    },
    15: {
      name: 'Life on land',
      description: 'Protect, restore and promote sustainable use of terrestrial ecosystems, ' +
      'sustainably manage forests, combat desertification, and halt and reverse land ' +
      'degradation and halt biodiversity loss'
    },
    16: {
      name: 'Peace, justice and strong institutions',
      description: 'Promote peaceful and inclusive societies for sustainable development, ' +
      'provide access to justice for all and build effective, accountable and inclusive ' +
      'institutions at all levels'
    },
    17: {
      name: 'Partnerships for the goals',
      description: 'Strengthen the means of implementation and revitalize the global ' +
      'partnership for sustainable development'
    }
  });
